import React from "react"
import type { StepConfig, SelectOption } from "./types"
import { INPUT_CLASS } from "./constants"

interface IgnoreConfigProps {
  config: StepConfig
  ignoreReasons: SelectOption[]
  onChange: (updates: Partial<StepConfig>) => void
}

export function IgnoreConfig({
  config,
  ignoreReasons,
  onChange,
}: IgnoreConfigProps) {
  return (
    <div className="space-y-1">
      <label className="block text-xs font-medium text-gray-700">Reason</label>
      <select
        value={config.reason || "noise"}
        onChange={(e) => onChange({ reason: e.target.value })}
        className={INPUT_CLASS}
      >
        {ignoreReasons.map((r) => (
          <option key={r.value} value={r.value}>
            {r.label}
          </option>
        ))}
      </select>
    </div>
  )
}
